import * as Yup from "yup";

export const initialValues = {
  certification: "",
  yearOfCompletion: "",
  comment: "",
  certificationList: "",
  uploadCertificate: null,
};

export const validationSchema = Yup.object().shape({
  certification: Yup.string().required("Certification is required"),
  yearOfCompletion: Yup.number().required("Year of completion is required"),
  comment: Yup.string().notRequired(),
  certificationList: Yup.string().notRequired(),
  uploadCertificate: Yup.mixed().notRequired(),
});
